import type { DefaultQueryError } from '@ahm/api-wrappers-core';
import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import { getTips, type TipsParams } from './get-tips';
import type { Tip } from './types';
import { apiRoutes } from '@/api/api-routes';

export const useGetTips = (
  params: TipsParams,
  opts?: Omit<UseQueryOptions<Tip[], DefaultQueryError>, 'queryKey'>
) =>
  useQuery<Tip[], DefaultQueryError>({
    queryKey: [apiRoutes.master_data.tips, params],
    queryFn: () => getTips(params),
    ...opts,
  });
